/**
 * @file    useEyeIcon
 * @scope   SHARED
 * @summary Base64 eye icon used by the line-chart legend "Show All" selector.
 * @produces string (empty when the conversion fails)
 * @sideEffects Logs conversion errors.
 */
import { useMemo } from 'react';
import { eyeSvg } from 'constants/exportToImage';
import { svgToBase64 } from 'helpers/utilities';

export const useEyeIcon = () =>
  useMemo(() => {
    try {
      return svgToBase64(eyeSvg);
    } catch (error) {
      console.error('Error converting SVG to Base64:', error);
      return '';
    }
  }, []);
